(function () {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let ticking = false;

  function createProgressBar() {
    if (document.querySelector(".velora-scroll-progress")) return;

    const bar = document.createElement("div");
    bar.className = "velora-scroll-progress";
    document.body.appendChild(bar);
  }

  function updateProgressBar() {
    const bar = document.querySelector(".velora-scroll-progress");
    if (!bar) return;

    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

    bar.style.width = progress + "%";
  }

  function initSectionReveal() {
    const sections = document.querySelectorAll(
      ".velora-hero-3d, .velora-scent-galaxy, .velora-world, .velora-products, .velora-values, .velora-editorial"
    );

    sections.forEach(function (section) {
      section.classList.add("velora-scroll-reveal");
    });

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function updatePremiumScroll() {
    if (reduceMotion) return;

    const sections = document.querySelectorAll(
      ".velora-hero-3d, .velora-scent-galaxy, .velora-world"
    );

    sections.forEach(function (section) {
      const rect = section.getBoundingClientRect();
      const sectionCenter = rect.top + rect.height / 2;
      const screenCenter = window.innerHeight / 2;
      const distance = (screenCenter - sectionCenter) / window.innerHeight;

      const isMobile = window.innerWidth < 750;

      const sectionMove = isMobile ? distance * -10 : distance * -28;
      const depthUp = isMobile ? distance * -18 : distance * -55;
      const depthSoft = isMobile ? distance * -8 : distance * -26;
      const glowMove = isMobile ? distance * 28 : distance * 70;

      section.style.setProperty("--velora-section-move", sectionMove + "px");
      section.style.setProperty("--velora-depth-up", depthUp + "px");
      section.style.setProperty("--velora-depth-soft", depthSoft + "px");
      section.style.setProperty("--velora-depth-glow", glowMove + "px");
    });
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateProgressBar();
        updatePremiumScroll();
        ticking = false;
      });

      ticking = true;
    }
  }

  function initPremiumScroll() {
    document.body.classList.add("velora-scroll-ready");

    createProgressBar();
    updateProgressBar();
    initSectionReveal();
    updatePremiumScroll();

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPremiumScroll);
  } else {
    initPremiumScroll();
  }
})();